import type { SponsoredAgentLoadedAction } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const SPONSORED_AGENT_LOADED = 'SPONSORED_AGENT_LOADED';

export function sponsoredAgentLoaded(sponsoredAgent: string | null): SponsoredAgentLoadedAction {
  return {
    type: SPONSORED_AGENT_LOADED,
    payload: { sponsoredAgent },
  };
}
